import './EmailSettings.css';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Form from 'react-bootstrap/Form';

function EmailSettings() {
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(false);
    const [sourceEmail, setSourceEmail] = useState('');
    const [replyEmail, setReplyEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [header, setHeader] = useState('');
    const [body, setBody] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [businessAddress, setBusinessAddress] = useState('');
    const [businessWebsite, setBusinessWebsite] = useState('');
    const [businessPhone, setBusinessPhone] = useState('');
    const [notificationEmail, setNotificationEmail] = useState('');
    const [secretAccessKey, setSecretAccessKey] = useState('');
    const [accesssKeyID, setAccessKeyID] = useState('');
    const emailSettings = useSelector(store => store.emailSettings);

    const editEmailMode = () => {
        setSourceEmail(emailSettings.source_email);
        setReplyEmail(emailSettings.reply_to_email);
        setSubject(emailSettings.subject);
        setHeader(emailSettings.header);
        setBody(emailSettings.body);
        setBusinessName(emailSettings.business_name);
        setBusinessAddress(emailSettings.business_address);
        setBusinessWebsite(emailSettings.business_website);
        setBusinessPhone(emailSettings.business_phone);
        setNotificationEmail(emailSettings.notification_email);
        setSecretAccessKey(emailSettings.api_secret_key);
        setAccessKeyID(emailSettings.api_normal_key);


        if (editMode === false) {
            setEditMode(!editMode);
        }
        else {
            setEditMode(!editMode);
            axios.put(`/api/emailSettings/update`, {
                source_email: sourceEmail,
                reply_to_email: replyEmail,
                subject: subject,
                header: header,
                body: body,
                business_name: businessName,
                business_address: businessAddress,
                business_website: businessWebsite,
                business_phone: businessPhone,
                notification_email: notificationEmail,
                api_secret_key: secretAccessKey,
                api_normal_key: accesssKeyID
            })
                .then((response) => {
                    dispatch({ type: 'FETCH_EMAIL_SETTINGS' });
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }

    const handleKeyPressEmail = e => {
        if (e.key === 'Enter') {
            editEmailMode();
        }
    };

    useEffect(() => {
        dispatch({ type: 'FETCH_EMAIL_SETTINGS' });
    }, []);
    return (
        <Table striped bordered hover id='email-table'>
            <tbody >
                <tr >
                    <th colSpan="2" width="15%">
                        <Button
                            onClick={editEmailMode}
                            variant={editMode ? "primary" : "outline-primary"}
                            size="md">Edit</Button>{' '}
                    </th>
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Sending Email
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setSourceEmail(e.target.value) })}
                            value={sourceEmail}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.source_email} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Reply To Email
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setReplyEmail(e.target.value) })}
                            value={replyEmail}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.reply_to_email} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Subject
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setSubject(e.target.value) })}
                            value={subject}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.subject} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Header
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                        as="textarea"
                        rows="2"
                            className="text-left py-0 my-2"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setHeader(e.target.value) })}
                            value={header}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.header} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Body
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            as="textarea"
                            rows="3"
                            className="text-left  py-0 my-2"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setBody(e.target.value) })}
                            value={body}
                            required
                        ></Form.Control>
                        <Form.Text className="text-muted">
                            The client name and request ID will be automatically included above the body in the email.
                            Example: "Client: Jane Doe | Request ID: 1042"
                        </Form.Text>
                        </td> : <td className="align-middle"> {emailSettings.body} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Business Name
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setBusinessName(e.target.value) })}
                            value={businessName}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.business_name} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Business Address
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setBusinessAddress(e.target.value) })}
                            value={businessAddress}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.business_address} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Business Website
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setBusinessWebsite(e.target.value) })}
                            value={businessWebsite}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.business_website} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Business Phone
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setBusinessPhone(e.target.value) })}
                            value={businessPhone}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.business_phone} </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Notification Email
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setNotificationEmail(e.target.value) })}
                            value={notificationEmail}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> {emailSettings.notification_email} </td>}
                </tr>


{/*}
                            <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Secret Access Key
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setSecretAccessKey(e.target.value) })}
                            value={secretAccessKey}
                            required
                        ></Form.Control> </td> : <td className="align-middle">  </td>}
                </tr>
                <tr>
                    <td width="15%" className="text-center font-weight-bold align-middle">
                        Access Key ID
    </td>
                    {editMode ? <td className="py-0 align-middle">
                        <Form.Control
                            className="text-left   py-0 my-0"
                            onKeyPress={handleKeyPressEmail}
                            onChange={((e) => { setAccessKeyID(e.target.value) })}
                            value={accesssKeyID}
                            required
                        ></Form.Control> </td> : <td className="align-middle"> </td>}
                </tr>
  */}
            </tbody>
        </Table>
    );
}

export default EmailSettings;